module.exports = __webpack_public_path__ + "e017651df0da640be1b1e0fef775c7f9.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-54@2x.png
// module id = 524
// module chunks = 0